/**
 * Donator user types.
 */
export enum DonatorUserType {
  Individual = 'individual',
  Corporation = 'corporation',
}
